/** Phase a progress report refers to. */
export enum ProgressType {
  Execution = 0,
  Network = 1,
}
